// @flow
import * as React from 'react'
import { Text } from 'core/Text'
import ErrorIcon from 'icon/ErrorIcon'
import Loader from 'ui/Loader'
import NoMatch from 'ui/NoMatch'
import { PageShell } from 'ui/Page'
import Header from './Header'
import Query from './Query'
import Viewer from './Viewer'
import './HandbookPage.module.scss'

type Props = {
  schoolSlug: string,
}

export default function HandbookPage(props: Props) {
  const { schoolSlug } = props

  const queryProps = {
    variables: {
      schoolSlug,
    },
  }

  const metatags = [{ name: 'robots', content: 'noindex' }]

  return (
    <PageShell contentWidthConstraint={false} metatags={metatags}>
      <Query {...queryProps}>
        {({ data, loading, error }) => {
          if (loading) return renderLoading()
          if (error) return renderError()

          return renderContent(data)
        }}
      </Query>
    </PageShell>
  )
}

function renderContent(data) {
  const { school } = data
  if (!school) return <NoMatch />
  if (!school.handbook) return <NoMatch />
  // HACK (jake): adding to help with this fiasco: https://wonderschool.slack.com/archives/C592XK0BS/p1556228493027400
  // we temporarily closed the school and don't want the handbook to be accessible
  if (school.closedAt) return <NoMatch />

  return (
    <div styleName="container">
      <Header school={school} />
      <Viewer handbook={school.handbook} />
    </div>
  )
}

function renderLoading() {
  return <Loader />
}

function renderError() {
  return (
    <div styleName="errorContainer">
      <div styleName="errorIcon">
        <ErrorIcon />
      </div>
      <Text size="twentyTwo">Sorry, something went wrong!</Text>
    </div>
  )
}
